import { Status } from 'shared/types';

export const tagSizes = ['sm', 'md', 'lg'] as const;
export type TagSize = (typeof tagSizes)[number];

export const closeButtonDisplays = ['always', 'never', 'hover'] as const;
export type CloseButtonDisplay = (typeof closeButtonDisplays)[number];

export type TagVariant = Status;
